import React from "react";
import { ArcStack } from "@src/core/ui";
import { OrdersWrapperView, ToggleCollapseView } from '@src/features/order/pages/orders-page/components';
import { ArcOrderCard } from "@src/core/components";
import { OrderStatusEnum } from "@src/features/order/entities";
import { useNavigate } from "react-router-dom";
import ViewAllButton from '@src/features/order/pages/orders-page/actions/view-all-button';
import { ErrorSectionProps } from "./types";

const ErrorSection: React.FC<ErrorSectionProps> = (props) => {
  const { orders, selected, onSelectOrder, count } = props;
  const navigate = useNavigate();

  const redirectToHistory = (status?: OrderStatusEnum) => {
    const url = `/app/history?status=${status}`;
    navigate(url);
  };

  return (
    <ArcStack direction='column' width='20%' height='100%' sx={{ display: 'flex', flexDirection: 'column' }}>
      <ToggleCollapseView count={count} status={OrderStatusEnum.ERROR}>
        <OrdersWrapperView>
          {orders.slice(0, 5).map((order, index) => {
            const orderId =
              (order as any).orders?.[0]?.id ||
              (order as any).id ||
              (order as any).missionId;
            const selectedId =
              (selected as any)?.orders?.[0]?.id ||
              (selected as any)?.id ||
              (selected as any)?.missionId;

            return (
              <ArcOrderCard
                key={orderId}
                order={order}
                isSelected={!!(orderId && selectedId && orderId === selectedId)}
                onClick={() => onSelectOrder(order, OrderStatusEnum.ERROR)}
                index={index}
                status={OrderStatusEnum.ERROR}
                sx={{ width: '100%', minHeight:'110px' }}
              />
            );
          })}
          {count > 5 && (
            <ViewAllButton
              onClick={() => redirectToHistory(OrderStatusEnum.ERROR)}
              status={OrderStatusEnum.ERROR}
            />
          )}
        </OrdersWrapperView>
      </ToggleCollapseView>
    </ArcStack>
  );
};

export default ErrorSection;
